import { defineMessages } from "react-intl";

import { node as colonoscopy } from "src/modules/ktx/forms/transplantation-screening/tumour-research/colonoscopy";
import { node as dentalScreening } from "src/modules/ktx/forms/transplantation-screening/tumour-research/dentalScreening";
import { node as dermatology } from "src/modules/ktx/forms/transplantation-screening/tumour-research/dermatology";
import { node as earNoseThroat } from "src/modules/ktx/forms/transplantation-screening/tumour-research/earNoseThroat";
import { node as gynecology } from "src/modules/ktx/forms/transplantation-screening/tumour-research/gynecology";
import { node as mammography } from "src/modules/ktx/forms/transplantation-screening/tumour-research/mammography";
import { node as ophthalmology } from "src/modules/ktx/forms/transplantation-screening/tumour-research/ophthalmology";
import { node as urology } from "src/modules/ktx/forms/transplantation-screening/tumour-research/urology";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "ktx.tomour_research",
		defaultMessage: "Góc és Tumorkutatás"
	}
});

export const node: ParentNode = {
	id: "ktx-tomour-research",
	value: { type: "wizard", title: messages.title },
	children: [
		dermatology,
		colonoscopy,
		dentalScreening,
		earNoseThroat,
		mammography,
		gynecology,
		ophthalmology,
		urology
	]
};
